<template>
  <div class="home-main-container" id="anchor">
    <Banner :bannerData="bannerData"></Banner>
    <HomeCard :title="$t('FoundationProject')" style="background-color: #fff;" toMorwUrl="/foundationProject">
      <template v-slot:content>
        <div style="width: 100%;">
          <FoundationProject :foundationProjectList="foundationProjectList"></FoundationProject>
        </div>
      </template>
    </HomeCard>
    <!-- 专项基金 -->
    <!-- <HomeCard :title="$t('SpecialFund')" style="background-color: #fff;" toMorwUrl="/specialFund">
      <template v-slot:content>
        <div style="width: 100%;">
          <SpecialFund :specialFundList="specialFundList"></SpecialFund>
        </div>
      </template>
    </HomeCard> -->

    <!-- swiper -->
    <HomeCard :title="$t('SpecialFund')" style="background-color: #fff;" toMorwUrl="/specialFund">
      <template v-slot:content>
        <div class="swiper-list-box">
          <div class="swiper-list-content">
            <swiper class="swiper-ls" :options="swiperOptions" ref="mySwiper">
              <swiper-slide v-for="(item,index) in specialFundList" :key="index">
                <!-- 幻灯片内容 -->
                <img :src="item.imgUrl" alt="" style="width:100%;height:100%;"  @click="toDetails(item.id,item.status)">
                <div class="swiper-box">
                  <div class="swiper-box-title">{{ item.name }}</div>
                  <div class="swiper-box-content">
				  {{ item.content }}
				  </div>
                </div>
              </swiper-slide>

              
            </swiper>
            <!-- 导航按钮 -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </div>
          
        </div>
        
      </template>
    </HomeCard>
    



    

    <HomeCard :title="$t('CorrelationNews')" style="background-color: white;" toMorwUrl="/news">
      <template v-slot:content>
        <div style="width: 100%;">
          <News :newsList="newsList"></News>
        </div>
      </template>
    </HomeCard>
    <div class="pc-bg" v-if="screenWidth>540">
      <div style="display: flex;gap: 2%;">
        <!-- <div style="width: 49%;float: left;">
          

          </div>
        </div>
        <div class="home-card-height1" style="width: 49%;float: left;background-size:100% 100%;background-repeat: no-repeat;" :style="{'background-image': 'url('+aboutFoundation.imgUrl+')',}">

        </div> -->
        <div style="width: 100%;display: flex;align-items: center;padding-top:8rem;padding-left:6rem;">
          <div style="width: 38rem;color: white;">
            <div style="line-height: 2rem;font-weight: 600;">
              <div style="overflow: hidden;" class="home-item-title">{{aboutFoundation.title}}</div>
            </div>
            <div class="news-abstract">
              <span v-html="aboutFoundation.digest"></span>
            </div>
            <div style="margin-top: 3rem;color: black;" class="look-more" @click="()=>{$router.push('/organizationalProfile/foundationIntroduction')}">
              {{$t('View')}} <i class="el-icon-arrow-right"></i>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div style="width: 100%;box-sizing: border-box;background-color: #B8210F;overflow:hidden"  v-if="screenWidth<=540">
      <div class="home-card-padding" style="width: 105%;color: white;padding: 3rem 0 0 2rem;box-sizing: border-box;background-position:right bottom;background-size:65%;background-repeat:no-repeat;" :style="{ backgroundImage: `url(${aboutFoundation.extId})` }">
        <div style="font-size: 1.5rem;font-weight: 600;text-align: center;width:calc(100% - 4.5rem);">
          <h2 class="home-item-title">{{aboutFoundation.title}}</h2>
        </div>
        <div>
          <el-row :gutter="10" style="width: 100%;">
            <el-col :span="14">
              <div style="font-size: 1.05rem;color:#FBE5E4;line-height:2rem;color:#FAE2E1;text-align: justify;">
                <span v-html="aboutFoundation.digest"></span>
              </div>
              <div style="margin: 2rem 0 4rem 0;color: black;" class="look-more" @click="()=>{$router.push('/organizationalProfile/foundationIntroduction')}">
                {{$t('View')}} <i class="el-icon-arrow-right"></i>
              </div>
            </el-col>
            <!-- <div style="width:100%;position: absolute;bottom: 0;left: 40%;z-index:9;"> -->
            <!-- <img :src="aboutFoundation.imgUrl" alt="" width="70%" style="position: absolute;bottom: 0;left: 30%;z-index:1 !important;"> -->
            <!-- </div> -->

          </el-row>
        </div>
      </div>
    </div>
    <!-- <div>
          <img :src="aboutFoundation.imgUrl" alt="" width="100%">
        </div> -->
    <div class="home-card-padding" style="text-align: center;background-color: #FFFFFF;">
      <h2 style="margin-top:0;margin-bottom:2rem" class="home-item-title">{{ $t('FoundingSupportingInstitutionsFoundation') }}</h2>

      <div style="width: 90%;display: flex;align-items: center;justify-content: center;margin: 0 auto;">
        <el-row :gutter="10">
          <el-col :span="screenWidth<=540?8:4" style="" v-for="item in institutionLogoData" :key="item">
            <div style="width:100%;">
              <img :src="item" alt="" width="100%" class="img-shadow">
            </div>
          </el-col>
        </el-row>
        <!-- <div class="institution-logo-item" v-for="item in institutionLogoData" :key="item" :style="{'background-image': 'url('+item+')',}">

        </div> -->
      </div>
    </div>
    <div style="text-align: center;padding-top: 0;background-color: #FFFFFF;">
      <h2 style="margin-bottom:2rem;margin-top:0" class="home-item-title">{{ $t('CouncilMembers') }}</h2>
      <ImageCarousel></ImageCarousel>

    </div>

    <div style="width: 100%;box-sizing:border-box;padding:1.5rem;display: flex;align-items: center;justify-content: right;padding-top: 1rem;background-color: #FFFFFF;">
      <sidewButton @goTop="goTop"></sidewButton>
    </div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { pageArticleByModuleId, listBannerByModuleId, listInfo, listSpecFund } from '@/api/index'
import ArticlesLsit from '@/components/articlesList/ArticlesList.vue'
import Skeleton from '@/components/skeleton/Skeleton.vue'
import HomeCard from '@/components/homeCard'
import HomeAside from './componets/HomeAside.vue'
import HomeNavchild from './componets/HomeNavChild.vue'
import News from './componets/News.vue'
import SpecialFund from './componets/SpecialFund.vue'
import FoundationProject from './componets/FoundationProject.vue'
import ImageCarousel from '@/components/ImageCarousel/index.vue'
import sidewButton from '@/components/sideButton/sidewButton.vue'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['screenWidth']),
    swiperInstance() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  components: {
    // swiper,
    // swiperSlide,
    ArticlesLsit,
    Skeleton,
    HomeAside,
    HomeNavchild,
    HomeCard,
    News,
    SpecialFund,
    FoundationProject,
    ImageCarousel,
    sidewButton
  },
  data() {
    return {
      swiperOptions:{
        // 启用模块
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,  // 添加循环滚动
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          hideOnClick: false
        },
        // 动态更新处理
        observer: true,
        observeParents: true
      },
      councilImgs: [],
      aboutFoundation: {},
      foundationProjectList: [],
      specialFundList: [],
      newsList: [],
      foundationIntroductionList: [],
      bannerData: [
      ],
      institutionLogoData: [
      ],
      // 下拉框配置
      options: [
        {
          value: 3,
          label: '3天内'
        },
        {
          value: 7,
          label: '7天内'
        },
        {
          value: 30,
          label: '30天内'
        },
        {
          value: 0,
          label: '全部'
        }
      ],
      // 排序栏配置
      sortType: [
        { name: '推荐', id: 200 },
        { name: '最新', id: 300 },
        { name: '热榜', id: 3 }
      ],
      // 选中下拉框的内容
      value: '',
      // 请求参数
      //  * @param {num} sort_type - 排序类别
      //  * 推荐：200
      //  * 最新：300
      //  * 热榜3天内：3
      //  * 热榜7天内：7
      //  * 热榜30天内：30
      //  * 热榜全部：0
      //  * @param {string} cursor - 偏移量
      //  * @param {num} limit - 请求数量
      params: {
        sort_type: 200,
        cursor: '0',
        limit: 20
      },
      // 文章列表
      articlesLsit: [],
      // 选中的排序方式
      checked: '',
      // 官网的要求,点击热门后才会出现
      showSelector: false,
      // 是否在发起上拉刷新请求
      isLoading: false,
      // 是否在发起新分类请求(与上拉触底的不一样)
      isLoadingSkeleton: false
    }
  },
  created() {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'never');
    document.head.appendChild(meta);
    // 触底后会有一个 homeToBottom 发送过来
    this.$bus.$on('homeToBottom', this.getNewDate)
    // 导航分类变化时，homeCateChange 会发送过来
    this.$bus.$on('homeCateChange', (cate_id) => {
      // console.log('我的分类子列表', list, cate_id)
      document.documentElement.scrollTop = 0

      this.$message.success(
        `分类ID：${cate_id},接口没有分类参数，这里走传参流程`
      )
    })
    // 页面刷新时读取点击状态
    this.checked = window.sessionStorage.getItem('checked') || '推荐'
    this.value = window.sessionStorage.getItem('value') || ''
    this.showSelector = this.checked === '热榜' ? true : false
    this.params.sort_type = window.sessionStorage.getItem('sort_type ') || 200
    this.getData()
    this.getAboutFoundation()
    this.listFoundingSupportingInstitutionsOfTheFoundation()


    // this.swiperInstance
  },
  mounted() {
    // console.log(this.swiperInstance,'---------',this.$refs.mySwiper);
    this.swiperInstance
  },
  methods: {
	  // 专项基金跳转
	  toDetails(id,status) {
	  	if(status == 0){
	  		const routeUrl = this.$router.resolve({
	  		    path: '/specialFundDetails',
	  		    query: {
	  		    id: id
	  		    }
	  		})
	  		window.open(routeUrl.href, "_blank")
	  	}
	  },
    goTop() {
      document.querySelector('#anchor').scrollIntoView(true)
    },
    arrowClick(val) {
      if (val === 'next') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    async getData() {
      this.newsList = (await this.pageArticleByModuleIds()).records
      let foundationProjectList = (await this.listSpecFunds(1)).records
      this.foundationProjectList = foundationProjectList.length > 8 ? foundationProjectList.slice(0, 8) : foundationProjectList
      this.specialFundList = (await this.listSpecFunds(2)).records
      this.foundationIntroductionList = (await this.pageArticleByModuleIds(9, 1, 1)).records
      this.listBannerByModuleIds()
    },
    listBannerByModuleIds() {
      const formData = new FormData();

      // 添加字符串类型的数据
      formData.append("moduleId", 1);
      listBannerByModuleId(formData).then(res => {
        if (res.data && res.data != null) {
          this.bannerData = res.data
        }

      })
    },
    async pageArticleByModuleIds(moduleId, page, size, title) {
      let res = await pageArticleByModuleId({
        "moduleId": moduleId || 1,
        "page": page || 1,
        "size": size || 10,
        "title": title || ""
      })
      if (res.data && res.data != null) {
        return res.data
      } else {
        return ''
      }

    },


    async listSpecFunds(moduleId) {
      let res = await listSpecFund({
        "type": moduleId,
        "page": 1,
        "size": 9
      })
      if (res.data && res.data != null) {
        return res.data
      } else {
        return ''
      }

    },

    //关于基金会
    getAboutFoundation() {
      const formData = new FormData();
      formData.append("moduleId", 17);
      listInfo(formData).then(res => {
        if (res.data && res.data != null) {
          this.aboutFoundation = res.data[0];
        }
      })
    },
    //获取基金会创始支持机构
    listFoundingSupportingInstitutionsOfTheFoundation() {
      const formData = new FormData();
      formData.append("moduleId", 18);
      listInfo(formData).then(res => {
        if (res.data && res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.institutionLogoData.push(res.data[i].imgUrl);
          }
        }
      })
    },

    // 获取文章
    async getArticles(type) {
      // 分类变化时刷新数据
      if (type === 'refresh') {
        // 第一次获取数据应重置偏移量
        this.params.cursor = '0'
        this.isLoadingSkeleton = true
        console.log('发起新请求')
        const { data: res } = await reqArticle(this.params)
        // 获取偏移量
        this.params.cursor = res.cursor
        this.articlesLsit = res.data
        this.isLoadingSkeleton = false
        console.log(res)
      }
      // 触底时拼接新旧数据
      else {
        this.isLoading = true
        console.log('发起拼接请求')
        const { data: res } = await reqArticle(this.params)
        // 获取偏移量
        this.params.cursor = res.cursor
        this.articlesLsit = [...this.articlesLsit, ...res.data]
        this.isLoading = false
        console.log(res)
      }
    },
    // 触底后发起拼接请求
    getNewDate() {
      // 防止多次请求
      if (this.isLoading) return
      console.log('home连接新数据')
      // this.getArticles()
    },
    // 点击分类栏
    refreshSortType(name, id) {
      this.checked = name
      window.sessionStorage.setItem('checked', name)
      window.sessionStorage.setItem('sort_type ', id)
      if (name === '热榜') this.showSelector = true
      else this.showSelector = false
      this.params.sort_type = id
      // this.getArticles('refresh')
    },
    // 监听下拉框的点击
    handleChange(id) {
      this.params.sort_type = id
      window.sessionStorage.setItem('sort_type ', id)
      this.options.forEach((item) => {
        if (item.value === id)
          window.sessionStorage.setItem('value', item.label)
      })
      console.log(id)
      // this.getArticles('refresh')
    }
  },
  beforeDestroy() {
    this.$bus.$off('homeToBottom')
    this.$bus.$off('homeCateChange')
  }
}
</script>

<style lang="less" scoped>
:deep(.el-input__inner) {
  width: 8rem;
}
// .swiper-container {
//   padding: 2rem 5%;
//   background: #fff;
// }
.swiper-list-box{
  width: 100%;
  position: relative;
  .swiper-list-content{
    padding: 2rem 5%;
    position: relative;
    .swiper-ls{
      overflow: hidden;
    }
  }
  // 添加以下样式
  &:hover {
    .swiper-button-prev,
    .swiper-button-next {
      // opacity: 1;
    }
  }
  
  .swiper-button-prev,
  .swiper-button-next {
    // opacity: 0;
    // transition: opacity 0.3s;
    
    &:after {
      font-size: 1.5rem;
      color: #aa221d;
    }
  }

  
  // background: #fff;
}
.swiper-box{
  background: #f8f8f8;
  padding: 1.5rem 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  height: 12.2rem;
  .swiper-box-title {
    font-weight: 1000;
    font-size: 1rem;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 隐藏超出的内容 */
    text-overflow: ellipsis;
  }
  .swiper-box-content{
    font-size: 0.8rem;
    display: -webkit-box;
    -webkit-line-clamp: 7; /* 显示的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
    margin-top: 0.5rem;
    line-height: 1.5rem;
  }
}

.pc-bg{
  background-image:url(../../assets/img/pc_bg.jpg);
  background-repeat:no-repeat;
  background-size:cover;
  width: 100%;
  height: 36rem;
}

.home-main-container {
  margin-top: 0;
  // margin-bottom: 2rem;
  .home-box {
    position: relative;
  }

  .home-content {
    width: 700px;
    margin-right: auto;
    background-color: #fff;
    min-height: 100vh;
    border-radius: 2px;

    .header {
      font-size: 1.17rem;
      padding: 1rem 1.6rem;
      border-bottom: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
      height: 2.4rem;
      margin-bottom .params {
        font-size: 1.2rem;
        color: var(--taojin-font-3);
        cursor: pointer;
      }

      .params:hover {
        color: var(--taojin-brand-2-hover);
        cursor: pointer;
      }

      .hidden {
        visibility: hidden;
      }
    }

    .loading {
      margin: 1rem auto;
      text-align: center;
    }
  }
}

.actived {
  color: var(--hover-color) !important;
}

.look-more {
  width: 6.5rem;
  padding: 0.5rem;
  background-color: #f8f8f8;
  height: 1.5rem;
  line-height: 1.5rem;
  text-align: center;
  border-radius: 1.5rem;
}
.news-abstract {
  overflow: hidden;
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 2.3rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}

.institution-logo-item {
  float: left;
  width: 14%;
  margin: 0 1.3%;
  height: 8rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.institution-logo-item1 {
  float: left;
  width: 28%;
  margin: 0 1.3%;
  height: 8rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.home-card-height1 {
  height: 28rem;
}

.home-item-title{
  font-size: 2.2rem;
}
.img-shadow{
  box-shadow: #f0eeee 0px 0px 0.3rem;
}
.home-card-padding{
  padding: 3rem 0;
  box-sizing: border-box;
}
img {
  vertical-align: middle;
}
</style>
